<template>
    <div>
        <div class="ak-upload-warp" :style="styles">
            <div v-if="uploadUrl" class="hover-wrap" :style="styles">
                <img :src="uploadUrl" alt="" />
                <div class="mask" :style="styles" @click="uploadClickHandler()">
                    修改
                </div>
            </div>
            <el-upload
                v-show="!uploadUrl"
                id="ak-upload"
                class="ak-upload"
                action=""
                :accept="accept"
                :show-file-list="false"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
                :on-error="uploadErrorHandler"
                :on-progress="uploadProgressHandler"
            >
                <i class="el-icon-plus ak-upload-icon"></i>
                <span v-if="placeholder">{{ placeholder }}</span>
            </el-upload>
            <el-radio-group class="hide" v-model="uploadUrl"></el-radio-group>
            <cropper
                ref="crop"
                :visible.sync="dialog.cropperVisible"
                :src="insideSrc"
                @on-crop="cropped"
                @reset="uploadClickHandler"
            ></cropper>
        </div>
        <div class="tips">{{ `${acceptTips}，且大小不超过${limit}MB` }}</div>
    </div>
</template>
<script>
import { ApiUploadFile } from '@/api/upload';
import Cropper from '../Cropper';
export default {
    name: 'upload',
    components: {
        Cropper
    },
    props: {
        type: {
            type: String,
            default: 'img'
        },
        clearable: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        url: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: '80'
        },
        accept: {
            type: String,
            default: 'png,jpg,jpeg'
        },
        limit: {
            type: Number,
            default: 100
        },
        maxW: {
            type: Number
        },
        imgWidth: {
            type: Number
        },
        again: {
            type: Boolean,
            default: false
        },
        scale: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: '请上传'
        },
        crop: {
            type: Boolean,
            default: () => false
        },
        radius: {
            type: String,
            default: '0'
        }
    },
    model: {
        prop: 'url',
        event: 'update'
    },
    data() {
        return {
            dialog: {
                cropperVisible: false
            },
            uploadUrl: '',
            insideSrc: ''
        };
    },
    watch: {
        url: {
            handler: function(val) {
                this.uploadUrl = val;
            },
            immediate: true,
            deep: true
        }
    },
    computed: {
        acceptTips() {
            const acceptList = this.accept.split(',');
            return `只支持${acceptList.join('、')}格式`;
        },
        styles() {
            return {
                width: this.width + 'px',
                height: (this.height || this.width) + 'px',
                borderRadius: this.radius + 'px'
            };
        }
    },
    methods: {
        delHandler() {
            this.uploadUrl = '';
            this.$emit('update', this.uploadUrl);
        },
        uploadClickHandler() {
            document.querySelector(`#ak-upload input`).click();
        },
        beforeUpload(file) {
            const type = file.name.substring(file.name.lastIndexOf('.') + 1);
            const isLimit = file.size / 1024 / 1024 < this.limit;
            if (this.accept.indexOf(type) < 0) {
                this.$message.error(this.acceptTips);
                return false;
            }
            if (!isLimit) {
                this.$message.error(`上传文件大小不能超过 ${this.limit}MB!`);
                return false;
            }
            if (this.crop) {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = event => {
                    this.insideSrc = event.srcElement.result;
                };

                this.dialog.cropperVisible = true;
                return false;
            } else {
                if (this.type === 'img' && (this.scale || this.imgWidth)) {
                    return new Promise((resolve, reject) => {
                        const _URL = window.URL || window.webkitURL;
                        const image = new Image();
                        image.onload = () => {
                            let valid = false;
                            if (this.imgWidth) {
                                valid = image.width === this.imgWidth;
                            } else if (this.scale) {
                                valid =
                                    image.width === image.height &&
                                    (this.maxW
                                        ? image.width <= this.maxW
                                        : true);
                            }
                            valid ? resolve() : reject(new Error());
                        };
                        image.src = _URL.createObjectURL(file);
                    }).then(
                        () => {
                            return file;
                        },
                        () => {
                            if (this.imgWidth) {
                                this.$message.error(
                                    `上传图片尺寸不符合,宽度固定为${this.imgWidth}!`
                                );
                            } else if (this.maxW) {
                                this.$message.error(
                                    `上传图片尺寸不符合,最大为${this.maxW}*${this.maxW},且比例必须为1:1!`
                                );
                            } else {
                                this.$message.error(
                                    '上传图片尺寸不符合,比例必须为1:1!'
                                );
                            }
                            return Promise.reject(new Error());
                        }
                    );
                }
            }
        },
        uploadProgressHandler() {
            this.$loading.open();
        },
        uploadErrorHandler(err) {
            this.$loading.close();
            this.$message.error('上传失败!' + err);
        },
        handleSuccess(res) {
            this.$loading.close();
            if (res.data) {
                this.uploadUrl = res.data;
                this.$emit('update', this.uploadUrl);
            } else {
                this.$message.error(res.message);
            }
        },
        async cropped(blob, name) {
            const formData = new FormData();
            formData.append(
                'file',
                new window.File([blob], name, {
                    type: 'image/png'
                })
            );
            formData.append('appId', 'akucun-saas-merchant');
            const { data } = await ApiUploadFile(formData);
            this.uploadUrl = data;
            this.$emit('update', this.uploadUrl);
            this.dialog.cropperVisible = false;
        }
    }
};
</script>
<style lang="scss" scoped>
.ak-upload-warp {
    position: relative;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 2px;
    cursor: pointer;
    margin: 0 auto;
    & > div {
        width: 100%;
        height: 100%;
    }
    .ak-upload,
    ::v-deep {
        .el-upload {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;

            span {
                margin-top: 10px;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.65);
                line-height: 22px;
            }
        }
    }
    .ak-upload-icon {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.45);
    }
    .ak-img {
        width: 100%;
        width: 100%;
        display: block;
    }
    .clear {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        width: 18px;
        height: 16px;
        background: url(../../assets/imgs/clear.png) no-repeat;
        background-size: cover;
        cursor: pointer;
    }
    .again {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 10;
        width: 100%;
        height: 23px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.85);
        line-height: 23px;
        text-align: center;
        background: #252525;
        opacity: 0.69;
        cursor: pointer;
    }
    .hover-wrap {
        position: relative;
        img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
        }
        .mask {
            display: none;
            position: absolute;
            justify-content: center;
            align-items: center;
            top: 0;
            left: 0;
            background: #000;
            opacity: 0.5;
            color: #fff;
            font-size: 14px;
        }
        &:hover {
            .mask {
                display: flex;
            }
        }
    }
}
.tips {
    margin-top: 5px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    text-align: center;
}
</style>
